/**
 * @fileoverview GET handler for the "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesAppGroupIdLandingPageIdPreview } from "./constants";
import type {
  GetEngagementLandingPagesAppGroupIdLandingPageIdPreviewProps,
  EngagementLandingPagesAppGroupIdLandingPageIdPreviewGetResult,
} from "./types";

export const getEngagementLandingPagesAppGroupIdLandingPageIdPreview = reactQueryFetcherAdapter(
  engagementLandingPagesAppGroupIdLandingPageIdPreview,
  (
    signal: AbortSignal,
    props: GetEngagementLandingPagesAppGroupIdLandingPageIdPreviewProps
  ): Promise<EngagementLandingPagesAppGroupIdLandingPageIdPreviewGetResult> => {
    const { appGroupId, landingPageBsonId, isPreview } = props;
    return fetch(
      `/engagement/landing_pages/${appGroupId}/${landingPageBsonId}/preview`,
      "GET",
      { is_preview: isPreview },
      { signal }
    );
  }
);
